import { ChangeDetectionStrategy, Component, CUSTOM_ELEMENTS_SCHEMA, Input } from '@angular/core';
import { PalantirAvatarComponent } from '../../avatar/avatar.component';
import { PalantirIconComponent } from '../../icon/icon.component';
import { PalantirMapComponent } from '../../map/map.component';
import { PalantirStarsComponent } from '../../stars/stars.component';
import { PalantirTagComponent } from '../../tag/tag.component';
import { PalantirTextComponent } from '../../text/text.component';
import { PalantirToolbarComponent } from '../../toolbar/toolbar.component';
import type { PalantirEntityChangeLogItem } from '../entity-change-logs.type';

@Component({
  selector: 'palantir-entity-change-log-item',
  templateUrl: './entity-change-log-item.component.html',
  styleUrls: ['./entity-change-log-item.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    PalantirAvatarComponent,
    PalantirIconComponent,
    PalantirTextComponent,
    PalantirStarsComponent,
    PalantirTagComponent,
    PalantirToolbarComponent,
    PalantirMapComponent,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class PalantirEntityChangeLogItemComponent {
  @Input({ required: true }) public item!: PalantirEntityChangeLogItem;
}
